import React from 'react';
import useAuth from '../../../../../hooks/authentication/useAuth';
import { Navigate, useNavigate } from 'react-router-dom';
import { LoginForm } from '../../../../login/LoginForm';
import { AuthenticationsLayout } from '../../../../layouts/Authentications/AuthenticationsLayout';
import ButtonOutlined from '../../../../shared/Buttons/ButtonOutlined';
import { useTranslation } from 'react-i18next';
import { SubmitButtonWrapper } from '../../../../styled/Form/SubmitButtonWrapper';

export const Login: React.FC = () => {
    const auth = useAuth();

    const { t } = useTranslation();

    let navigate = useNavigate();
    const routeChange = () => {
        let path = `/registration`;
        navigate(path);
    };

    if (auth.isLoggedIn) {
        auth.forceLogout();
    }

    return (
        <>
            {/*{auth.isLoggedIn && <Navigate to={'/'} replace />}*/}
            {/*{!auth.isLoggedIn && (*/}
            <AuthenticationsLayout>
                <LoginForm />
                <SubmitButtonWrapper>
                    <ButtonOutlined
                        type="submit"
                        sx={{
                            height: '40px',
                            width: '100%',
                            marginTop: '15px',
                        }}
                        onClick={routeChange}
                    >
                        {t('LOGIN_PAGE.REGISTRATION').toString()}
                    </ButtonOutlined>
                </SubmitButtonWrapper>
            </AuthenticationsLayout>
            {/*)}*/}
        </>
    );
};
